// This file is generated.
export var version = '0.3.8';
//# sourceMappingURL=version.js.map